import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import s from './Terms.scss';
import translations from '../../assets/locales/messages_en.json';
import Secured from '../../assets/icons/Secured.svg?url';
import PaymentMethods from '../../assets/icons/PaymentMethods.svg?url';
import PaymentMethodsColor from '../../assets/icons/PaymentMethodsColor.svg?url';
import DaysGuaranty from '../../assets/icons/DaysGuaranty.svg?url';

export interface TermsProps extends WithTranslation, InjectedExperimentsProps {
  isPriceIncludedTax: boolean;
}

class Terms extends React.Component<TermsProps> {
  getIcon = (name: string) => {
    switch (name) {
      case 'PaymentMethods':
        const shouldShowColorPaymentMethods = this.props.experiments.enabled(
          'specs.ascend.PackagePickerColoredPaymentMethods',
        );
        return (
          <img
            data-hook={`payment-methods-${
              shouldShowColorPaymentMethods ? 'color' : 'gray'
            }`}
            src={
              shouldShowColorPaymentMethods
                ? PaymentMethodsColor
                : PaymentMethods
            }
            alt="Payment Methods"
          />
        );
      case 'DaysGuaranty':
        return <img src={DaysGuaranty} alt="Days Guaranty" />;
      case 'Secured':
        return <img src={Secured} alt="Secured" />;
      default:
        return <div />;
    }
  };

  renderWithIcon = (name: string, title: string, icon: string) => {
    const shouldShowColorPaymentMethods = this.props.experiments.enabled(
      'specs.ascend.PackagePickerColoredPaymentMethods',
    );
    return (
      <div className={s.terms} data-hook="terms-terms">
        <div className={s.termsTextBox} data-hook="terms-textBox">
          <div className={s.termsTitle} data-hook={`terms-title-${name}`}>
            {title}
          </div>
          <div
            className={
              shouldShowColorPaymentMethods
                ? s.termsFullIconNew
                : s.termsFullIcon
            }
            data-hook={`terms-icon-${name}`}
          >
            {this.getIcon(icon)}
          </div>
        </div>
      </div>
    );
  };

  renderWithText = (
    name: string,
    title: string,
    description: string,
    icon: string,
  ) => (
    <div className={s.terms} data-hook="terms-terms">
      <div className={s.termsIcon} data-hook={`terms-icon-${name}`}>
        {this.getIcon(icon)}
      </div>
      <div className={s.termsTextBox} data-hook="terms-textBox">
        <div className={s.termsTitle} data-hook={`terms-title-${name}`}>
          {title}
        </div>
        <div
          className={s.termsDescription}
          data-hook={`terms-description-${name}`}
        >
          {description}
        </div>
      </div>
    </div>
  );

  renderTerm = () => {
    const { t } = this.props;
    return this.props.isPriceIncludedTax
      ? t('terms.title.withTax')
      : t('terms.title.withoutTax');
  };

  render() {
    const { t } = this.props;

    return (
      <div className={s.strip} data-hook="terms-strip">
        <div className={s.root} data-hook="terms">
          <div className={s.separatorHorizontal} />
          <div className={s.title} data-hook="terms-title">
            {this.renderTerm()}
          </div>
          <div className={s.listOfTerms} data-hook="terms-listOfTerms">
            {this.renderWithIcon(
              'payment',
              t('terms.title.1'),
              translations['terms.iconFull.1'],
            )}
            <div className={s.separatorVertical} />
            {this.renderWithText(
              'daysGuaranty',
              t('terms.title.2'),
              t('terms.description.2'),
              translations['terms.icon.2'],
            )}
            <div className={s.separatorVertical} />
            {this.renderWithText(
              'secured',
              t('terms.title.3'),
              t('terms.description.3'),
              translations['terms.icon.3'],
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withExperiments(Terms));
